import { render, staticRenderFns } from "./homeEarlyWarning.vue?vue&type=template&id=21fe4764&scoped=true&"
import script from "./homeEarlyWarning.vue?vue&type=script&lang=js&"
export * from "./homeEarlyWarning.vue?vue&type=script&lang=js&"
import style0 from "./homeEarlyWarning.vue?vue&type=style&index=0&id=21fe4764&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fe4764",
  null
  
)

export default component.exports